import { addToast } from "@caprikorn/dynamo-ui";
import { useMutation } from "@tanstack/react-query";

import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { unauthenticatedApiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";

const postResetPassword = (email: string) =>
  unauthenticatedApiEcmsHttp.post("/public/reset-password", {
    email,
  });

export const usePostResetPassword = () => {
  const { t } = useCustomTranslation(["main", "common"]);

  return useMutation({
    mutationFn: ({ email }: { email: string }) => postResetPassword(email),
    retry: false,
    mutationKey: [QUERY_KEYS.PASSWORD_RESET],
    onSuccess: () => {
      addToast({
        variant: "success",
        title: t("resetPasswordRequest.successTitle"),
        description: t("resetPasswordRequest.successDescription"),
      });
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("errors.generic.title", { ns: "common" }),
        description: t("errors.generic.description", { ns: "common" }),
      });
    },
  });
};
